import * as ReselectModule from "reselect";
import { ITemplateDocumentListState } from ".";
import { IApplicationState } from "..";

export const selectTemplateDocumentList: ReselectModule.Selector<
  IApplicationState,
  ITemplateDocumentListState
> = (state) => state.templateDocumentList;
